<section id="secao-numeros-graduadas">
  <div class="container">
    <div class="row justify-content-center fundo-azul">
      <svg
        class="pp-small-triangle"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        fill="#ffffff"
        width="100%"
        height="20"
        viewBox="0 0 0.156661 0.1"
      >
        <!-- <polygon
          points="0.156661,3.93701e-006 0.156661,0.000429134 0.117665,0.05 0.0783307,0.0999961 0.0389961,0.05 -0,0.000429134 -0,3.93701e-006 0.0783307,3.93701e-006 "
        ></polygon> -->
      </svg>
      <div class="descricao p-4">
        <h3 class="box-titulo">
          <span class="titulo">
            As empresas mantenedoras da Educere - graduadas e parceiras - geraram em 2024:
          </span>
        </h3>
        <hr class="hr" />
      </div>
      <div class="row">
        <div class="col c-numeros py-4 px-5">
          <span class="caixa-numero">
            <span>
              <p>
                <strong class="numero">+320</strong>
              </p>
            </span>
            <p class="sub">milhões</p>
            <p class="sub-sub">em faturamento bruto</p>
          </span>
        </div>
        <div class="col c-numeros py-4 px-5">
          <span class="caixa-numero">
            <span>
              <p>
                <strong class="numero">+52</strong>
              </p>
            </span>
            <p class="sub">milhões</p>
            <p class="sub-sub">em impostos arrecadados</p>
          </span>
        </div>
        <div class="col c-numeros py-4 px-5">
          <span class="caixa-numero">
            <span>
              <p>
                <strong class="numero">+430</strong>
              </p>
            </span>
            <p class="sub">empregos</p>
            <p class="sub-sub">de alta especialização gerados</p>
          </span>
        </div>
      </div>
    </div>
  </div>
</section>
